import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="py-6 px-8 bg-surface border-t border-outline-variant/5">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-secondary/40 text-center md:text-left leading-relaxed">
          AI agents can make mistakes. Please verify important information before making financial decisions.
        </p>
        <div className="flex items-center gap-6">
          <span className="text-[10px] font-bold text-secondary/30 tracking-widest uppercase">
            © 2026 Agent Capital
          </span>
          <a
            href="mailto:support@agentcapital.com"
            className="text-[10px] font-bold text-secondary/30 tracking-widest uppercase hover:text-primary transition-colors"
          >
            Support
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
